import { Injectable, inject } from '@angular/core';
import { assert } from '../assert/assert';
import { WINDOW } from '../../features/calendar/util/browser-window-ref';

type CronJob = {
  func: () => void;
  interval: number;
  lastExecution: number;
};

@Injectable({ providedIn: 'root' })
export class CronJobsService {
  private readonly jobs = new Map<string, CronJob>();
  // DI
  private readonly window = inject<Window>(WINDOW);

  constructor() {
    this.executeCronJobs();
  }

  registerJob(func: () => void, interval: number): string {
    const uuid = crypto.randomUUID();
    this.jobs.set(uuid, {
      func,
      interval,
      lastExecution: Date.now(),
    });
    return uuid;
  }

  deregisterJob(cronJobIndex: string): void {
    assert(this.jobs.has(cronJobIndex));
    this.jobs.delete(cronJobIndex);
  }

  private executeCronJobs(): void {
    this.window.setInterval(() => {
      const now = Date.now();
      this.jobs.forEach((cronJob) => {
        if (now - cronJob.lastExecution >= cronJob.interval) {
          cronJob.func();
          cronJob.lastExecution = now;
        }
      });
    }, 100);
  }
}
